import { IState } from '../../store';

export const selectIsPurchaseTermsEnabled = (state: IState) => state.featureToggle.isPurchaseTermsEnabled;
